import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "paymentInfo",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17702",
		"data-name": "Group 17702",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13092",
				"data-name": "Path 13092",
				d: "M17,21a5,5,0,0,1-5-5,5.078,5.078,0,0,1,5.005-5A5,5,0,0,1,17,21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13093",
				"data-name": "Path 13093",
				d: "M2,6.85H21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13094",
				"data-name": "Path 13094",
				d: "M21,13V5a2,2,0,0,0-2-2H4A2,2,0,0,0,2,5v9a2,2,0,0,0,2,2h8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13095",
				"data-name": "Path 13095",
				d: "M19.222,14.889l-2.778,2.778L14.778,16",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13096",
		"data-name": "Path 13096",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgPaymentInfo;
